import http from "@/http/aisea/axios";

// 運航レポート（次航連絡/輸送実績）の PORT_HIERARCHY_PICKER / CARGO_PICKER の
// ID→名称解決に使う、運航管理マスタ取得 API。
const resource = "/enterprises/operations/master";

export default {
  /**
   * 港マスタ（港/地区/バースの3階層）を取得する
   * @returns {Promise<Object>} res.data = { ports: [{ id, name, districts: [{ id, name, berths: [{ id, name }] }] }] }
   */
  ports(params = {}) {
    return http.get(`${resource}/ports`, { params });
  },

  /**
   * 貨物種類マスタを取得する
   * @returns {Promise<Object>} res.data = { cargo_types: [{ id, name, units, cargo_category_id, disabled }] }
   */
  cargoTypes(params = {}) {
    return http.get(`${resource}/cargo-types`, { params });
  },
};
